<template>
  <gg-card class="app-card">
    <gg-card-header>
      Social Media
    </gg-card-header>
    <gg-card-text class="pa-4">
      <v-row>
        <v-col cols="12">
          <v-form>
            <v-row>
              <v-col cols="12" md="6">
                <gg-text-field label="Facebook Link"
                              v-model="facebook"
                              name="facebook"
                              outlined
                              autocomplete="new-password"
                              data-vv-as="Facebook Link"
                              :error-messages="errors.collect('facebook')" />
              </v-col>
              <v-col cols="12" md="6">
                <gg-text-field label="Twitter Link"
                              v-model="twitter"
                              name="twitter"
                              outlined
                              autocomplete="new-password"
                              data-vv-as="Twitter Link"
                              :error-messages="errors.collect('twitter')" />
              </v-col>
              <v-col cols="12" md="6">
                <gg-text-field label="Instagram Link"
                              v-model="instagram"
                              name="instagram"
                              outlined
                              autocomplete="new-password"
                              data-vv-as="Instagram Link"
                              :error-messages="errors.collect('instagram')" />
              </v-col>
              <v-col cols="12" md="6">
                <gg-text-field label="Pinterest Link"
                              v-model="pinterest"
                              name="pinterest"
                              outlined
                              autocomplete="new-password"
                              data-vv-as="Pinterest Link"
                              :error-messages="errors.collect('pinterest')" />
              </v-col>
              <v-col cols="12">
                <gg-text-field label="LinkedIn Link"
                              v-model="linkedIn"
                              name="linkedIn"
                              outlined
                              autocomplete="new-password"
                              data-vv-as="LinkedIn Link"
                              :error-messages="errors.collect('linkedIn')" />
              </v-col>
            </v-row>
          </v-form>
        </v-col>
      </v-row>
    </gg-card-text>
  </gg-card>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'

export default {
  name: 'SocialMedia',
  computed: {
    ...mapGetters({
      model: 'wizard_model/starterSite'
    }),
    facebook: {
      get () {
        return this.model.socialFacebook
      },
      set (val) {
        this.setFacebook(val)
      }
    },
    twitter: {
      get () {
        return this.model.socialTwitter
      },
      set (val) {
        this.setTwitter(val)
      }
    },
    instagram: {
      get () {
        return this.model.socialInstagram
      },
      set (val) {
        this.setInstagram(val)
      }
    },
    pinterest: {
      get () {
        return this.model.socialPintrest
      },
      set (val) {
        this.setPinterest(val)
      }
    },
    linkedIn: {
      get () {
        return this.model.socialLinkedIn
      },
      set (val) {
        this.setLinkedIn(val)
      }
    },
  },
  methods: {
    ...mapMutations({
      setFacebook: 'wizard_model/SET_SS_FACEBOOK',
      setTwitter: 'wizard_model/SET_SS_TWITTER',
      setInstagram: 'wizard_model/SET_SS_INSTAGRAM',
      setPinterest: 'wizard_model/SET_SS_PINTEREST',
      setLinkedIn: 'wizard_model/SET_SS_LINKEDIN',
    }),
  },
}
</script>
